module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAWCAYAAADeiIy1AAAABHNCSVQICAgIfAhkiAAAAHhJREFUSEtjZMACli9f/h+bOCVijIPCosjISKwOIcVnsNDB66NRi/DFNyO+FEbVoKO7Rciuh1lOEx+NWkRspoVnWGzxMRpH+IKRqKAjNh6IUQcvGbAlb2IMIFYNVouI1YysjlACGsYWkRNc2PTgKh/xVhPkWI7LIgDfnKpL3+uXtQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icn-blank.png
// module id = 3k20
// module chunks = 1